module.exports = __webpack_public_path__ + "public/img/ptz-icon2.02361277.svg";